import React, { useState } from 'react';

import { Alert, Form, Input, Typography } from 'antd';

import StepGuide from 'components/StepGuide';

import { Icon } from '@eduzz/ui-antd-theme';

import FaqLink from '../../Basic/FaqLink';

interface IProps {
  handleDomain: (domain: string) => void;
  validated: boolean;
  hasDomain: boolean;
  domain: string;
  loading: boolean;
}

function DomainForm({ hasDomain, validated, handleDomain, domain, loading }: IProps) {
  const faqUrl = 'https://ajuda.eduzz.com/?article=como-configurar-o-pixel-orbita';
  const message = validated
    ? 'Configurações ativas e disponíveis para uso, aproveite!'
    : 'A verificação ainda não foi realizada, aguarde um pouco mais.';

  const [handleDomainConfig, setHandleDomainConfig] = useState(false);

  return (
    <>
      <Typography.Link onClick={() => setHandleDomainConfig(!handleDomainConfig)}>
        {'Configurações de domínio  '}
        {handleDomainConfig ? <Icon.ChevronUp size={16} /> : <Icon.ChevronDown size={16} />}
      </Typography.Link>

      {handleDomainConfig && (
        <>
          <div className='mt-2' />
          <Typography.Paragraph type='secondary'>
            Para configurar seu domínio, siga os passos abaixo. Algumas das etapas são feitas fora da plataforma Eduzz.
          </Typography.Paragraph>
          <div className='mt-4' />
          <Typography.Paragraph type='secondary'>
            1 - Configure o dominio no Gerenciador de Negócios do Facebook{' '}
            <Typography.Link target='_blank' rel='noopener noreferrer' href='https://business.facebook.com/'>
              clicando aqui.&nbsp;
            </Typography.Link>
            <br />
            Acesse{' '}
            <Typography.Text strong>Configurações de Negócio &gt; Segurança da marca &gt; Domínios.</Typography.Text>
          </Typography.Paragraph>
          <div className='mt-2' />
          <Typography.Paragraph type='secondary'>
            2 - Registre seu CNAME seguindo os passos abaixo.
          </Typography.Paragraph>
          <div className='mt-2' />
          <StepGuide>
            No provedor do seu domínio vá em configurações de <Typography.Text>DNS</Typography.Text>
          </StepGuide>
          <StepGuide>
            Configure seu CNAME, apontando para <Typography.Text>pixel.eduzz.com</Typography.Text>
          </StepGuide>
          <StepGuide>Salve as configurações</StepGuide>
          <div className='mt-2' />
          <Form.Item label='3 - Copie e cole aqui seu CNAME.' extra='Ex: pixel.seudominio.com'>
            <Input size='small' disabled={loading} value={domain} onChange={(e: any) => handleDomain(e.target.value)} />
          </Form.Item>
          <div className='mt-2' />
          <Typography.Paragraph type='secondary'>
            4 - A Validação será automática e assim que feita estará disponível para uso. Esse processo pode demorar até
            72 horas.
          </Typography.Paragraph>
          <div className='mt-2' />

          {hasDomain && (
            <>
              <Alert type={validated ? 'info' : 'warning'} message={message} />
              <div className='mt-2' />
            </>
          )}
          <div className='flex w-full justify-center'>
            <FaqLink link={faqUrl} />
          </div>
          <div className='mt-4' />
        </>
      )}
    </>
  );
}

export default React.memo(DomainForm);
